import { useEffect, useRef } from 'react';

import { useSystemAutomation } from '../../contexts/system-automation-context';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { PackingRecommendations } from '../../constants/features';

/**
 * Silently creates and activates the "Recommend Package" system automation rule the first time
 * a seller with the PackingRecommendations feature enabled loads the app - so sellers who enable
 * the feature don't have to visit Settings > Warehouse > Packing for it to take effect.
 */
export const PackingRecommendationAutoEnabler = () => {
  const isPackingRecommendationsFeatureEnabled = useIsSellerFeatureEnabled(PackingRecommendations);
  const { getPackingRecommendationRule, togglePackingRecommendationRule, isLoading } = useSystemAutomation();
  const hasAttemptedAutoCreateRef = useRef(false);

  useEffect(() => {
    if (!isPackingRecommendationsFeatureEnabled || isLoading || hasAttemptedAutoCreateRef.current) return;
    if (getPackingRecommendationRule()) return;

    hasAttemptedAutoCreateRef.current = true;
    togglePackingRecommendationRule(true, { silent: true }).catch(() => {
      // Error handling and notification are already done in SystemAutomationContext
    });
  }, [isPackingRecommendationsFeatureEnabled, isLoading, getPackingRecommendationRule, togglePackingRecommendationRule]);

  return null;
};
